import '@babel/runtime/helpers/esm/jsx';
import 'styled-components';
import { jsx, Fragment } from 'react/jsx-runtime';

const StyleSheetManager=a=>{let{children:b}=a;return/*#__PURE__*/jsx(Fragment,{children:b})};StyleSheetManager.displayName="StyleSheetManager";

export { StyleSheetManager as default };
